import { Component, OnInit, AfterViewInit, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-addpayrolegrp',
  templateUrl: './addpayrolegrp.component.html',
  styleUrls: ['./addpayrolegrp.component.css']
})
export class AddpayrolegrpComponent implements OnInit,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
  
formname:String="PayrollGroup"; 
//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading: boolean = false;
isprivilage: boolean = false;
showProgress: boolean = false;


//Save Validation
submitted:boolean;
successfully:boolean;
saveloading: boolean;

//Edit Get Values
payrollgrpColl:any=[];
payrollgrpBO:any={};

payrollgrpid:number=0

payrollgrpform=new FormGroup({
  payrollgrpid:new FormControl(0),          
  payrollgrpname:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.payrollgrpid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges() {
  this.loginService.serviceAuthChange.subscribe((value) => {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.fnUserFailedForm();
    }

  });
}



ngOnInit() {
  try {
    if (this.loginService.fnCheckCompany()) {
      if (this.fnCheckUserPririvilage()) {
        this.isloading = true;
        this.fnOnInitForm();
      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnGetUserRoleList();
    }

  } catch (ex) {
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm() {
   try{
       this.isaddmode=true;
       this.payrollgrpform.reset();
       this.fnInitializeFormGroup(); 

       if(this.payrollgrpid>0){
         this.fngetPayrolegrp();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

fnCheckUserPririvilage() {
  var _check: boolean = false;
  if (this.payrollgrpid > 0) {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
  } else {
    _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
  }

  return _check;
}

fnUserFailedForm() {
  this.isprivilage = true;
}

ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}

fnInitializeFormGroup(){
   this.payrollgrpform.setValue({
    payrollgrpid:0,    
    payrollgrpname:'',
     inactive:false              
   })
}

//Get 
fngetPayrolegrp() {  
  if (this.showProgress) {
    return;
  }

  this.fnShowProgress();      
     var data = {
       'payrollgrpid':this.payrollgrpid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getPayrollgrp(data)
     .subscribe(
       (res)=>{                
         if(res.json().status===200){  
          this.fnHideProgress();

           this.payrollgrpColl=res.json().result;
           var editdata = this.payrollgrpColl[0];        
           this.fnEditMode(editdata);
           this.payrollgrpBO=editdata;
         }
         else {
          this.fnHideProgress();

           this.loginService.fnAPIError(res.json())
         }
         
     },
     (err)=>{   
      this.fnHideProgress();
       
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{ if (this.saveloading) {
    return;
  }

     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.payrollgrpform.valid){ this.saveloading = true;
         //Check
         var data = {
               'payrollgrpid': this.payrollgrpid,                      
               'payrollgrpname':this.payrollgrpform.get('payrollgrpname').value, 
               'inactive':this.payrollgrpform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                             
         }

       
         this.appService.fnCheckPayrollgrp(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.payrollgrpform.get('payrollgrpid').value>0){
                       //Update 
                       this.fnSetPayrollgrp(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertPayrollgrp(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){ this.saveloading = false;
                       this.payrollgrpform.controls['payrollgrpname'].setErrors({'notfound': true});
                     }
               }
             }
             else { this.saveloading = false;
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{ this.saveloading = false;
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){ this.saveloading = false;
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertPayrollgrp(data){    
 
   this.appService.fnInsertPayrollgrp(data).subscribe(
     (res)=>{ this.saveloading = false;
       if(res.json().status===200){  
         if(res.json().result!=""){
           this.toastr.success('', "The new payrollgrp has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.payrollgrpname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{ this.saveloading = false;
       this.toastr.error('Error', err);
     });

}

//Set
fnSetPayrollgrp(data){    

this.appService.fnSetPayrollgrp(data).subscribe(
 (res)=>{ this.saveloading = false;
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The payrollgrp has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.payrollgrpid,data.payrollgrpname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{ this.saveloading = false;
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{
  this.router.navigate(['/Payrollgrp']);
}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.payrollgrpform.setValue({ 
  payrollgrpid:deptBO.payrollgrpid,     
  payrollgrpname:deptBO.payrollgrpname,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}
fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
}


private fnShowProgress() {
  this.showProgress = true;
}
private fnHideProgress() {
  this.showProgress = false;
}
private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}









}
